<template>
  <div class="container">
    <section>
      <div class="layout">
        <div class="child">
          <div class="pure-g">
            <div class="pure-u-1">
              <div>
                <h2>{{ questionTitle }}</h2>
              </div>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1">
              <div>
                <h3>
                  Now choose {{ answersAmount }} answers to this {{ indexText }} question. Make the
                  answers simple. Try to paint a picture with your words in the mind of the
                  respondent.
                </h3>
              </div>
            </div>
          </div>
          <IdeaCoach :key="answerIndex" :type="answerType" @submit="ideaCoachSubmitted" @idea="ideaCoachLaunched" />
          <div>
            <form class="pure-form pure-form-stacked" @submit.prevent="handleSubmit" novalidate>
              <fieldset>
                <div v-for="(answer, idx) in formModel.answers" :key="idx">
                  <div class="pure-g">
                    <div class="pure-u-1">
                      <span class="question-title" :class="answer.getClassObj()">{{
                        answer.getTitle()
                      }}</span>
                    </div>
                    <div class="pure-u-1">
                      <input type="text" :ref="answersRefName" v-model="answer.text" />
                    </div>
                  </div>
                </div>
                <button type="submit" class="hidden-submit"></button>
              </fieldset>
              <BigStudyNavigation @touched="onTouched"></BigStudyNavigation>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX,
  GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_OBJ,
  SET_IN_PROGRESS_STUDY_ANSWERS_OF_QUESTION_N,
  GET_IN_PROGRESS_STUDY_ANSWERS_AMOUNT,
  GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX_ENGLISH,
  GET_NEXT_STUDY_STEP_ROUTE,
  UPDATE_STUDY,
  CSS_CLASS_NAME_INVALID,
  IDEA_COACH_TYPE,
} from "../../services/constants";
import IdeaCoach from "../../components/idea-coach/IdeaCoach";

export default {
  name: "AnswersOfQuestionN",
  data() {
    return {
      formModel: null,
      submitTouched: false,
    };
  },
  components: { IdeaCoach },
  computed: {
    ...mapGetters([
      GET_NEXT_STUDY_STEP_ROUTE,
      GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_OBJ,
      GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX,
      GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX_ENGLISH,
      GET_IN_PROGRESS_STUDY_ANSWERS_AMOUNT,
    ]),
    questionTitle() {
      return this[GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_OBJ].name;
    },
    answersAmount() {
      return this[GET_IN_PROGRESS_STUDY_ANSWERS_AMOUNT];
    },
    indexText() {
      return this[GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX_ENGLISH];
    },
    answerIndex() {
      return this[GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX];
    },
    areAnswersValid() {
      return this.formModel.answers.map((answer) => {
        return answer.text.length > 0;
      });
    },
    isFormModelValid() {
      return this.areAnswersValid.every((isValid) => {
        return isValid;
      });
    },
    answersRefName() {
      return "answersRef";
    },
    answersValidUI() {
      return this.areAnswersValid.map((isValid) => {
        return !isValid && this.submitTouched;
      });
    },
    answersValidationClassObjs() {
      return this.answersValidUI.map((isInvalid) => {
        return {
          [CSS_CLASS_NAME_INVALID]: isInvalid,
        };
      });
    },
    answerType() {
      return IDEA_COACH_TYPE.answer;
    },
  },
  watch: {
    $route() {
      this.resetFormModel();
    },
  },
  methods: {
    handleSubmit() {
      if (this.isFormModelValid) {
        const answersOnlyText = this.formModel.answers.map((answer) => {
          return {
            text: answer.text,
          };
        });
        this.$store.commit(SET_IN_PROGRESS_STUDY_ANSWERS_OF_QUESTION_N, {
          i: this.answerIndex,
          answers: answersOnlyText,
        });
        this.$store.dispatch(UPDATE_STUDY).then(() => {
          this.submitTouched = false;
          this.$router.push(this[GET_NEXT_STUDY_STEP_ROUTE]);
        });
      }
    },
    resetFormModel() {
      const self = this;
      this.formModel = Object.assign(
        {},
        {
          answers: this[GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_OBJ].answers.map((answer, i) => {
            return {
              text: answer.text,
              getTitle() {
                return answer.name;
              },
              getClassObj() {
                return self.answersValidationClassObjs[i];
              },
            };
          }),
        }
      );
    },
    focusFirstQuestion() {
      //$nextTick only needed for Chrome, firefox works without it
      this.$nextTick(() => {
        this.$refs[this.answersRefName][0].focus();
      });
    },
    onTouched() {
      this.submitTouched = true;
    },
    ideaCoachLaunched() {
      const answersOnlyText = this.formModel.answers.map((answer) => {
        return {
          text: answer.text,
        };
      });
      this.$store.commit(SET_IN_PROGRESS_STUDY_ANSWERS_OF_QUESTION_N, {
        i: this.answerIndex,
        answers: answersOnlyText,
      });
    },
    ideaCoachSubmitted() {
      this.resetFormModel();
    },
  },
  created() {
    this.resetFormModel();
  },
  mounted() {
    this.focusFirstQuestion();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/main";

.container {
  height: 100%;
}

section {
  height: 100%;
}

.layout {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
}

.child {
  width: 100%;
  max-width: 500px;
  margin: 1em;
}

h2 {
  text-align: center;
  color: $red-2;
}

h3 {
  color: $cyan-blue-3;
}

.pure-form input[type="text"] {
  box-shadow: none;
  width: 100%;
  color: $cyan-blue-3;
  border-color: $cyan-blue-3;

  &:focus {
    border-color: $cyan-blue-1;
  }
  &:placeholder-shown {
    color: $gray-3;
  }
  &:-ms-input-placeholder {
    color: $gray-3;
  }
}

.question-title {
  font-size: 0.83em;
  font-weight: bold;
  color: $cyan-blue-3;
}

.invalid {
  color: $red-2;
}
</style>
